import { connect } from 'react-redux'
import {
  makeSelectItemById,
  selectCurrentFolderItemQueryId,
} from 'ducks/folders/selectors/items'
import {
  selectConversationUnreadCountByQueryId,
  selectEntityCountByQueryId,
} from 'ducks/searches/selectors'
import { removeKeysFromQueryId } from 'ducks/searches/utils/query'
import FolderView from './view'

const select = () => {
  const selectItemById = makeSelectItemById()

  return (state, props) => {
    const {
      name,
      queryId: fullQueryId,
      displayCountWhenInactive,
      hideIfZeroConversations,
      linkTo,
      displayUnreadIndicator,
    } = selectItemById(state, props)
    const currentFolderQueryId = selectCurrentFolderItemQueryId(state)
    const queryId = removeKeysFromQueryId(['orderBy', 'cursor'], fullQueryId)
    const current = queryId === currentFolderQueryId
    const conversationCount = selectEntityCountByQueryId(state, queryId)
    const alert =
      displayUnreadIndicator &&
      selectConversationUnreadCountByQueryId(state, queryId) > 0
    return {
      name,
      queryId,
      current,
      shouldDisplayCount: current || (!current && displayCountWhenInactive),
      hideIfZeroConversations,
      linkTo,
      alert,
      conversationCount,
    }
  }
}

export default connect(select)(FolderView)
